import { useCallback, useMemo } from "react";

export const useImageDimentions = (width?: number, height?: number) => {
  const getDimentions = useCallback(() => {
    if (!height || !width)
      return [
        { height: `330px`, width: `330px` },
        { height: `100%`, width: `100%` },
      ];
    const containerStyleToReturn: Record<string, string> = {};
    const imgStyleToReturn: Record<string, string> = {};

    if (height > width) {
      const aspectRatio = width / 240;
      containerStyleToReturn["width"] = `240px`;
      containerStyleToReturn["height"] = `330px`;
      imgStyleToReturn["width"] = `100%`;
      imgStyleToReturn["height"] = `${height / aspectRatio}px`;
    } else if (height < width) {
      containerStyleToReturn["width"] = `330px`;
      containerStyleToReturn["height"] = `${height / (width / 330)}px`;
      if (height * 3 < width) {
        containerStyleToReturn["height"] = `82.5px`;
        imgStyleToReturn["height"] = `100%`;
        imgStyleToReturn["width"] = `${width / (height / 82.5)}px`;
      } else {
        imgStyleToReturn["height"] = `${height / (width / 330)}px`;
        imgStyleToReturn["width"] = `100%`;
      }
    } else {
      containerStyleToReturn["width"] = `330px`;
      containerStyleToReturn["height"] = `330px`;
      imgStyleToReturn["height"] = `100%`;
    }
    return [containerStyleToReturn, imgStyleToReturn];
  }, [height, width]);

  return useMemo(() => getDimentions(), [getDimentions]);
};

const convertToReactNativeStyles = (style: { [key: string]: number | string }) => {
  const convertedStyle: {
    [key: string]: number | string;
  } = {};
  for (const key in style) {
    if (Object.prototype.hasOwnProperty.call(style, key)) {
      const value = style[key];
      if (typeof value === "string" && value.endsWith("px")) {
        convertedStyle[key] = parseFloat(value);
      } else {
        convertedStyle[key] = value;
      }
    }
  }
  return convertedStyle;
};

export const useReactNativeImageDimentions = (width?: number, height?: number) => {
  const [containerStyleToReturn, imgStyleToReturn] = useImageDimentions(width, height);
  return [convertToReactNativeStyles(containerStyleToReturn), convertToReactNativeStyles(imgStyleToReturn)];
};
